export function androany(daty : Date | undefined  | string | null) {
  if(daty == undefined || daty == null){
    return ""
  }  
  var  now = new Date(daty);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  
  // Exemple d'utilisation
  //const currentDate = androany();
  //console.log(currentDate); // Output: 2024-02-22
  